<template>
	<div class="content">
		<h2 class="mb-2">操作说明</h2>
		<div class="category-container">
			<div v-for="category in categories" :key="category.id" class="category-item">
				<!-- 一级分类 -->
				<div class="first-level">{{ category.name }}</div>
				<!-- 二级分类 -->
				<div v-if="category.childlist" class="second-level">
					<div v-for="child in category.childlist" :key="child.id" class="sub-category">
						{{ child.name }}
					</div>
				</div>
			</div>
		</div>
		<!-- <div v-html="richTextContent"></div> -->
	</div>
</template>

<script>
	export default {
		name: "doc",
		data() {
			return {
				items: [],
				categories: [],
				richTextContent: '补小帅APP商家端使用说明书'
			};
		},
		created() {
			this.fetchCategories();
		},
		methods: {
			fetchCategories() {
				this.$axios.get('/index/index/getArticleCategory')
					.then(response => {
						console.log('Category response:', response);
						if (response.data && response.data.data) {
							this.categories = response.data.data;
						} else {
							this.categories = response.data;
						}
						console.log('Categories after assignment:', this.categories);
					})
					.catch(error => {
						console.error('Error fetching categories:', error);
					});
			}
		}
	};
</script>

<style>
.mb-2 {
	text-align: center;
}
.category-container {
	margin-bottom: 20px;
}
.category-item {
	margin-bottom: 15px;
}
.first-level {
	font-weight: bold;
	font-size: 16px;
	color: #333;
	margin-bottom: 8px;
}
.second-level {
	padding-left: 20px;
}
.sub-category {
	color: #666;
	padding: 4px 0;
	font-size: 14px;
	cursor: pointer;
	position: relative;
	padding-left: 15px;
}
.sub-category:before {
	content: "•";
	position: absolute;
	left: 0;
	color: #666;
}
.sub-category:hover {
	color: #409EFF;
}
</style>